var _desc, _defs, _g, _filter, _tspan, _tspan2, _tspan3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateRc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "87fee6b1-6691-407f-8c42-aedaaed58799"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "e4bc2c20-2366-4bd3-a04d-765e5edc61c8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.7 0 0 8.95 540 511.56)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 26.64 -13.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-700, -622.5)",
    d: "M 645 915 L 620 891 L 620 653 L 620 415 L 653 360 C 671 330 692 305 700 305 C 708 305 729 330 747 360 L 780 415 L 780 653 L 780 891 L 755 915 C 740 931 719 940 700 940 C 681 940 660 931 645 915 z M 740 630 L 740 420 L 700 420 L 660 420 L 660 630 L 660 840 L 700 840 L 740 840 L 740 630 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0 2.66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-500.18, -502.55)",
    d: "M 76 882 C 61 865 60 826 62 484 L 65 105 L 500 105 L 935 105 L 938 484 C 941 917 944 900 861 900 L 815 900 L 818 820 L 822 740 L 861 740 L 900 740 L 900 440 L 900 140 L 500 140 L 100 140 L 100 440 L 100 740 L 339 740 L 578 740 L 582 820 L 585 900 L 339 900 C 113 900 92 899 76 882 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 428.06 729.24)",
    style: {
      filter: "url(#SVGID_60)"
    },
    id: "ce121832-968f-473f-aca6-5c63e64b672c"
  }, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "SVGID_60",
    y: "-35%",
    height: "170%",
    x: "-24%",
    width: "148%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 16.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "oBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "oBlur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "Lato",
    fontSize: 196,
    fontStyle: "normal",
    fontWeight: 400,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -217.76,
    y: 61.57
  }, "R")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -80.36,
    y: 61.57
  }, "C")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 69.58,
    y: 61.57
  }, "N")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRc);
export default __webpack_public_path__ + "static/media/createRC.c3b080d39a39eee42baac5cfe665c4b0.svg";
export { ForwardRef as ReactComponent };